module.exports = __webpack_public_path__ + "static/img/yxMLogo.38d12ea7.png";